import Html from "@core/libs/html";
import VoyoAppOptions from "../app/options";

class Search {
    constructor(
        protected html: Html,
        private options: VoyoAppOptions
    ) {
    }

    performSearch( query: string, tag: string): Promise<void> {
        // Get base url from current url. We cannot use options.routes.search because we
        // need to have oto or 5ka in url also
        const url = window.location.href.split('?')[0];

        return this.html
            .fetchText(url + '?q=' + encodeURIComponent(query) + '&tag=' + encodeURIComponent(tag))
            .then((data) => {
                const browserUrl = new URL(window.location.href);
                query ? browserUrl.searchParams.set('q', query) : browserUrl.searchParams.delete('q');
                tag ? browserUrl.searchParams.set('tag', tag) : browserUrl.searchParams.delete('tag');

                history.replaceState({}, '', browserUrl.toString());

                const [library, timeshift, libraryCount, timeshiftCount] = this.html.extractElements(data, [
                    '#searchResultsLibrary',
                    '#searchResultsTimeshift',
                    '#searchTypesLibrary .results-count',
                    '#searchTypesTimeshift .results-count',
                ]);

                this.html.writeHTML('#searchResultsLibrary', library?.innerHTML || '');
                this.html.writeHTML('#searchResultsTimeshift', timeshift?.innerHTML || '');

                this.html.setData('#searchTypesLibrary .results-count', 'total', libraryCount?.dataset.total || '');

                const timeshiftResults = this.html.q('#searchTypesTimeshift .results-count');
                if (timeshiftResults) {
                    this.html.setData(timeshiftResults, 'total', timeshiftCount?.dataset.total || '');
                }
            })
            .catch((err) => {
                app.error('Search failed:', err);
                throw err;
            });
    }
}

export default Search;
